/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../assets/styles/style.sass';
import s2 from './login.sass';
import RegisterModuleRedirectText from './RegisterModuleRedirectText';
import { setIsShowLoginModal } from '../../actions/user';
import { returnLocaleText } from '../../service/util';
import { ConnectedLoginForm } from '../../login-form/login-form.component';

class LoginModule extends React.Component {
  static propTypes = {
    isShowLoginModal: PropTypes.bool.isRequired,
    currentLocale: PropTypes.string.isRequired,
    setIsShowLoginModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      modelDataDefaultLocale: require(`../../assets/json/default/setting/general/locale.json`),
      modelDataLocale: require(`../../assets/json/${lang}/${fileLang}setting/general/locale.json`),
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.props.setIsShowLoginModal();
  }

  render() {
    return (
      <span>
        <Modal
          isOpen={this.props.isShowLoginModal}
          toggle={() => this.toggle()}
          style={{ marginTop: '200px' }}
          className={`${s2.resizeModal} text-center`}
          contentClassName={s2.resizeModalContent}
        >
          <Button
            outline
            color="link"
            onClick={this.toggle}
            className={`${s2.infoCloseRightButton}`}
          />
          <ModalBody
            style={{ backgroundColor: '#f7f7f7', borderRadius: '4px' }}
          >
            <ConnectedLoginForm onLogin={this.toggle} />
            <div className={s2.orLine}>
              <hr />
              <span className={s2.or}>
                {returnLocaleText(
                  this.state.modelDataLocale.login_modal_or,
                  this.state.modelDataDefaultLocale.login_modal_or,
                )}
              </span>
            </div>
            <span className={`${s.globalFontLight} ${s2.registerIfNotYet}`}>
              <RegisterModuleRedirectText
                lang={this.props.currentLocale}
                target="#register"
                toggle={this.toggle}
                normalText={returnLocaleText(
                  this.state.modelDataLocale.login_modal_normal_message,
                  this.state.modelDataDefaultLocale.login_modal_normal_message,
                )}
                btnText={returnLocaleText(
                  this.state.modelDataLocale
                    .login_modal_redirect_to_register_btn,
                  this.state.modelDataDefaultLocale
                    .login_modal_redirect_to_register_btn,
                )}
              />
            </span>
          </ModalBody>
        </Modal>
      </span>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  isShowLoginModal: state.user.isShowLoginModal,
});

const mapDispatch = {
  setIsShowLoginModal,
};

export default connect(mapState, mapDispatch)(withStyles(s, s2)(LoginModule));



// WEBPACK FOOTER //
// ./src/components/Login/LoginModule.js